import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { pickBy } from 'lodash';
import { dateFormat } from '../../../config';
import { amountFormater } from '../ManagePaymentListing/ColumnFormater';
import PaymentDetailsContainer from './PaymentDetailsContainer';
import { bacsPaymentProptypes } from '../../../states/managePayments/propTypes';
import PaymentDetailsTable from './PaymentDetailsTable';
import { formatAccountToView } from '../../../utils/accountUtils';

export const BacsCreditPaymentDetails = ({
	content: {
		fromLabel,
		totalAmountLabel,
		typeLabel,
		bacsIdLabel,
		createdByLabel,
		individualPaymentsLabel,
		settlementDateLabel,
		submissionDateLabel,
		createdOnLabel,
	},
	mandate: {
		amount,
		mandateType,
		bacsId,
		submissionDate,
		settlementDate,
		creator_name,
		created_timestamp,
		fromAccount,
		numberOfPayments,
	},
}) => {
	const tableRowMapping = pickBy({
		[typeLabel]: mandateType,
		[fromLabel]: formatAccountToView(fromAccount),
		[bacsIdLabel]: bacsId,
		[submissionDateLabel]: submissionDate,
		[settlementDateLabel]: settlementDate,
		[individualPaymentsLabel]: numberOfPayments,
		[totalAmountLabel]: amountFormater({ amount }),
		[createdByLabel]: creator_name,
		[createdOnLabel]: created_timestamp && moment(created_timestamp).format(dateFormat),
	});
	return <PaymentDetailsTable tableRowMapping={tableRowMapping} />;
};

BacsCreditPaymentDetails.propTypes = {
	mandate: PropTypes.shape(bacsPaymentProptypes).isRequired,
	content: PropTypes.shape({}).isRequired,
};

export default PaymentDetailsContainer(BacsCreditPaymentDetails);
